import { a as _objectSpread2 } from '../_rollupPluginBabelHelpers-1f0bf8c2.js';
import { createComponent } from 'reakit-system/createComponent';
import { createHook } from 'reakit-system/createHook';
import 'reakit-utils/shallowEqual';
import 'react';
import 'reakit-utils/useForkRef';
import 'reakit-utils/useIsomorphicEffect';
import '../Role/Role.js';
import '../findEnabledItemById-8ddca752.js';
import '../__keys-6742f591.js';
import '../Id/IdProvider.js';
import '../Id/Id.js';
import { b as GRID_ROW_KEYS } from '../__keys-08a69d36.js';
import '../Group/Group.js';
import { useCompositeGroup } from '../Composite/CompositeGroup.js';

var unstable_useGridRow = createHook({
  name: "GridRow",
  compose: useCompositeGroup,
  keys: GRID_ROW_KEYS,
  useProps: function useProps(_, htmlProps) {
    return _objectSpread2({
      role: "row"
    }, htmlProps);
  }
});
var unstable_GridRow = createComponent({
  as: "div",
  useHook: unstable_useGridRow
});

export { unstable_GridRow, unstable_useGridRow };
